/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _isMobile.default;
  }
});
var _isMobile = _interopRequireDefault(require("../packages/isMobile"));


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/isMobile.js
// module id = 72
// module chunks = 0